document.addEventListener("DOMContentLoaded", function() {
  // Select all slideshow controls
//   const dots = document.querySelectorAll(".slideshow-control");
//   dots.forEach(function(dot) {
//     // Clear existing number text
//     dot.textContent = "";
//     // Add Font Awesome star
//     dot.innerHTML = '<i class="fa-solid fa-star"></i>'; 
    
 
//   });
});